/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

import { ICommonTranslationWidget } from '../../types/common/widgets';

const initTranslationWidget: ICommonTranslationWidget = {
    from: '',
    to: '',
};

export default initTranslationWidget;
